var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { staticClass: "title is_show_flex" }, [
      _c("div", { staticClass: "between" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "span",
              {
                staticClass: "menuImg",
                on: {
                  click: function() {
                    return (_vm.isMore = !_vm.isMore)
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/menu.png"),
                    alt: ""
                  }
                })
              ]
            ),
            _c("span", { staticClass: "leftLine" }),
            _vm._l(_vm.tabList, function(item, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "menuTxt",
                  attrs: { href: "/list/category/" + item.toLowerCase() }
                },
                [_vm._v(_vm._s(item))]
              )
            })
          ],
          2
        ),
        _c("div", { class: ["center", _vm.isSearch ? "search-center" : ""] }, [
          _c("a", { staticClass: "flex-style", attrs: { href: "/" } }, [
            _c("img", {
              attrs: { src: require("@/assets/img/website/logo.png"), alt: "" }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "rightIcon ismobile" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/website/social.png") },
            on: { mouseenter: _vm.showPopover, mouseleave: _vm.hidePopover }
          }),
          _vm.showSocial
            ? _c(
                "div",
                {
                  staticClass: "social",
                  on: {
                    mouseenter: _vm.showPopover,
                    mouseleave: _vm.hidePopover
                  }
                },
                _vm._l(_vm.socialList, function(item) {
                  return _c(
                    "a",
                    {
                      key: item.id,
                      on: {
                        click: function($event) {
                          return _vm.toSocial(item.href)
                        }
                      }
                    },
                    [_c("img", { attrs: { src: item.imgUrl, alt: "" } })]
                  )
                }),
                0
              )
            : _vm._e()
        ]),
        _c("span", { staticClass: "rightIcon ismobile" }, [
          _c("img", {
            attrs: { src: _vm.langImg },
            on: { mouseenter: _vm.showPopover2, mouseleave: _vm.hidePopover2 }
          }),
          _vm.showLang
            ? _c(
                "div",
                {
                  staticClass: "lang",
                  on: {
                    mouseenter: _vm.showPopover2,
                    mouseleave: _vm.hidePopover2
                  }
                },
                _vm._l(_vm.langList, function(item) {
                  return _c("a", { key: item.id, attrs: { href: item.href } }, [
                    _vm._v(
                      "\n            " + _vm._s(item.label) + "\n          "
                    )
                  ])
                }),
                0
              )
            : _vm._e()
        ]),
        !_vm.isSearch
          ? _c("span", { staticClass: "rightLine ismobile" })
          : _vm._e(),
        !_vm.isSearch
          ? _c(
              "span",
              { staticClass: "rightIcon", on: { click: _vm.toSearch } },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/search.png"),
                    alt: ""
                  }
                })
              ]
            )
          : _vm._e(),
        _vm.isSearch
          ? _c(
              "div",
              { staticClass: "searchBox" },
              [
                _c("a-input", {
                  model: {
                    value: _vm.searchVal,
                    callback: function($$v) {
                      _vm.searchVal = $$v
                    },
                    expression: "searchVal"
                  }
                }),
                _c("span", { staticClass: "rightLine ismobile" }),
                _c(
                  "span",
                  { staticClass: "rightIcon", on: { click: _vm.search } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/website/search.png"),
                        alt: ""
                      }
                    })
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _c("div", { staticClass: "mobileHeader is_hide_block" }, [
      _c("div", { staticClass: "mbTitle" }, [
        _c(
          "div",
          {
            staticClass: "left",
            on: {
              click: function() {
                return (_vm.isMore = !_vm.isMore)
              }
            }
          },
          [
            _c("span", { staticClass: "menuImg" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/mb-menu.png"),
                  alt: ""
                }
              })
            ])
          ]
        ),
        _c("div", { staticClass: "center" }, [
          _c("a", { attrs: { href: "/" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/website/mb-logo.png"),
                alt: ""
              }
            })
          ])
        ]),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "mobileLang" }, [
            _c("div", { staticClass: "mobileLangDiv" }, [
              _c(
                "span",
                { staticClass: "rightIcon ismobile mobileLang-span" },
                [
                  _c("img", { attrs: { src: _vm.langImg, alt: "" } }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showLang,
                          expression: "showLang"
                        }
                      ],
                      staticClass: "lang"
                    },
                    _vm._l(_vm.langList, function(item) {
                      return _c(
                        "a",
                        { key: item.id, attrs: { href: item.href } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.label) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]),
            !_vm.isSearch
              ? _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "rightIcon mobileLang-span",
                      on: { click: _vm.toSearch }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/website/mb-search.png"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ])
              : _c(
                  "div",
                  [
                    _c("aInput", {
                      staticClass: "mb_input",
                      model: {
                        value: _vm.searchVal,
                        callback: function($$v) {
                          _vm.searchVal = $$v
                        },
                        expression: "searchVal"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "rightIcon mobileLang-span",
                        on: { click: _vm.search }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/website/mb-search.png"),
                            alt: ""
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "mbMenu" },
        _vm._l(_vm.tabList, function(item, idx) {
          return _c(
            "a",
            {
              key: idx,
              staticClass: "menuTxt",
              attrs: { href: "/list/category/" + item.toLowerCase() }
            },
            [_vm._v(_vm._s(item) + "\n      ")]
          )
        }),
        0
      )
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMore,
            expression: "isMore"
          }
        ],
        staticClass: "menuList mb-menuList",
        on: { mouseleave: _vm.closeMenulist }
      },
      [
        _c(
          "p",
          {
            staticClass: "mbClose is_hide_block",
            on: { click: _vm.closeMenulist }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/website/mb-close.png"),
                alt: ""
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "mb-menuBox" },
          [
            _vm.isMobile
              ? _c("p", { staticClass: "mb-menuTit" }, [
                  _vm._v("LANGUAGE SWITCHING")
                ])
              : _vm._e(),
            _vm.isMobile
              ? _c(
                  "div",
                  _vm._l(_vm.langList, function(item) {
                    return _c(
                      "a",
                      {
                        key: item.id,
                        staticClass: "mb-menutext",
                        attrs: { href: item.href }
                      },
                      [_c("span", [_vm._v(_vm._s(item.label))])]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.isMobile ? _c("p", { staticClass: "line mb-line" }) : _vm._e(),
            _c("p", { staticClass: "menuTit mb-menuTit" }, [
              _vm._v("CATEGORY")
            ]),
            _vm._l(_vm.tabList, function(item, idx) {
              return _c(
                "p",
                { key: idx, staticClass: "menutext mb-menutext" },
                [
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticStyle: { color: "white" },
                        attrs: { href: "/list/category/" + item.toLowerCase() }
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  ])
                ]
              )
            }),
            _c("p", { staticClass: "line mb-line" }),
            _vm._m(0),
            _vm._m(1)
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "about" }, [_c("span", [_vm._v("ARCHIVE")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "about", attrs: { href: "/detail/79687" } }, [
      _c("span", [_vm._v("ABOUT")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/views/components/header.vue?vue&type=template&id=5d5971fc&scoped=true&
// module id = 215
// module chunks = 0 1 2